import {Card, CardContent, CardMedia, CardProps, Typography} from "@mui/material";
import {ObjectDocument} from "../../../../types/pj1dbApiObject";

export interface ObjectListItemProps extends CardProps {
  item: ObjectDocument
}

export function ObjectListItem({item, ...props}: ObjectListItemProps) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Card {...props}  sx={{width: 240, ...props.sx}}>
      <CardMedia
        component="img"
        height="145"
        image={item.url?.thumbnail.original[0]}
        alt={item.attr['object-pkg-original-name']}
        sx={{objectFit: "scale-down"}}
      />
      <CardContent sx={{py: 0.5, px: 1, m: 0, textWrap: 'nowrap', overflowX: 'scroll'}}>
        <Typography variant="subtitle2" component='p' sx={{mt: 0.5}}>
          パッケージ名：{item.attr['object-pkg-original-name']}
        </Typography>
        <Typography variant="subtitle2" component='p' sx={{color: "#888"}}>
          オブジェクト名：{item.attr.original_name}
        </Typography>
      </CardContent>
    </Card>
  )
}
